module.exports = __webpack_public_path__ + "static/media/sss-phone.6699f6a5.svg";